/* DistributionCenter.icon.svg.js */

module.exports = {
    icon: `
            <svg class="center-vertically" viewBox="-227 229 24 24" preserveAspectRatio="none">
                <path class="foreground-gl" d="M-206.2,245.4h-2.5v-2.5h2.5 M-206.2,250.5h-2.5v-2.5h2.5 M-213.7,235.3h-2.5v-2.5h2.5 M-213.7,240.4h-2.5v-2.5h2.5
                    M-213.7,245.4h-2.5v-2.5h2.5 M-213.7,250.5h-2.5v-2.5h2.5 M-221.3,240.4h-2.5v-2.5h2.5 M-221.3,245.4h-2.5v-2.5h2.5 M-221.3,250.5
                    h-2.5v-2.5h2.5 M-211.2,240.4v-7.6l-3.8-3.8l-3.8,3.8v2.5h-7.6V253h22.7v-12.6H-211.2z"/>
            </svg>
         `
};
